var map = {
	"./office1.jpeg": 3864,
	"./office10.jpeg": 3432,
	"./office11.jpeg": 1327,
	"./office12.jpeg": 6546,
	"./office13.jpeg": 7177,
	"./office14.jpeg": 5948,
	"./office15.jpeg": 2627,
	"./office3.jpeg": 7218,
	"./office4.jpeg": 691,
	"./office5.jpeg": 6604,
	"./office6.jpeg": 6477,
	"./office7.jpeg": 8214,
	"./office8.jpeg": 3559,
	"./office9.jpeg": 8032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9701;